import gql from 'graphql-tag';

export const GET_LIST_PRODUCT_SEASON_MONTH = gql`
  fragment productSeasonMonthOne on product_season_month {
    id
    product_id
    season_month
  }
`;
